import { alovaInstance, type AlovaMeta, type ResponseType, withMeta } from "@@/alova";

// link: https://mock.metaapp.cn/project/378/interface/api/40729

export interface queryGameInfoOptions {
  /** 游戏id */
  gameId?: string;
  /** 包名 */
  packageName?: string;
  /** pcdn标记 */
  pcdnFlag?: string;
}

export interface queryGameInfoRes {
  resTagType64: any;
  developerWords: any;
  platformType: string;
  videos: any;
  modeRevenues: any;
  blacklistTips: any;
  tips: string;
  fileOriginalName: any;
  hasRealNameAuthentication: boolean;
  systemRequirements: any;
  needReptileUpdate: boolean;
  loginTypeFlag: number;
  bookingStatus: string;
  id: number;
  briefIntro: string;
  advertisingSdkTypeFlag: number;
  images: any;
  schemeGameExpand: any;
  appVersionName: string;
  uploadApkUserIp: string;
  commentCount: number;
  minAndroidSdkVersion64: number;
  tags: any;
  lockAttributeIds: string;
  isLandscape: any;
  apkUrl64: any;
  authorName: any;
  publicationId: any;
  iconHashType: string;
  supportSystemTypeFlag: number;
  hasOuterChain: boolean;
  resTag64: any;
  syncStatus: string;
  adsStatus: string;
  minAndroidSdkVersion: number;
  syncTime: string;
  iconUrl96: string;
  displayName: string;
  tabs: any;
  gameAppId: any;
  caFileSize: number;
  commentIds: string;
  iosIconUrl96: string;
  manufacturer: string;
  syncUser: any;
  endSHA164: any;
  guideVideos: any;
  isOverseasGameLock: boolean;
  ca: any;
  sensitiveSubjectsList: any;
  appVersionName64: any;
  hasPreventObsession: boolean;
  recentUpdates: any;
  businessStatus: string;
  updateTime: number;
  headPicture: any;
  activeStatus: string;
  regenerationMode: string;
  canUpdatePlatforms: any;
  contentGradings: any;
  supportSystemTypes: string;
  imageUrls: string[];
  gameLanguage: any;
  fileOriginalName64: any;
  shareUserUuid: string;
  coreTags: string;
  publicationStatus: string;
  iconHashCode: string;
  na64: any;
  appDownCount: number;
  operationStatus: string;
  rating: number;
  ageClass: string;
  adsMultiChannelStatus: string;
  source: string;
  realNameAuthenticationMethod: string;
  installEnvStatus: string;
  appVersionCode: number;
  tipsBlack: any;
  isNeedLinkNetwork: boolean;
  centralDirectorySHA164: any;
  resTag: string;
  beforeIsGameLock: any;
  iconUrl: string;
  videoIds: string;
  contentType: string;
  iconHeadTag: any;
  iconId: string;
  guideImages: any;
  resType: string;
  pcdnFlag: number;
  shortDescription: string;
  caCentralDirectorySHA1: any;
  displayLanguage: any;
  loginTypes: any;
  adsSource: any;
  homePagePicture: any;
  endSHA1: string;
  expand: any;
  na: string;
  fileSize: number;
  iosIconUrl256: string;
  adsTiming: any;
  updateIntro: any;
  appVersionCode64: number;
  recommendStatus: string;
  informations: any;
  testIcons: any;
  appName64: any;
  isGameLock: boolean;
  tagIds: number[];
  resType64: any;
  description: string;
  advertisingSdkTypes: any;
  fileSize64: number;
  testStatus: string;
  onlineTime: string;
  centralDirectorySHA1: string;
  packageName: string;
  adsQuantityStatus: string;
  bigPictures: any;
  appName: string;
  checkVersion: number;
  mainGameId: any;
  schemeGamePkg: any;
  fullLib: boolean;
  beforeRecommendStatus: any;
  resTagType: string;
  minUnpackVersion: any;
  updateStatus: string;
  iconUrl256: string;
  gameFlag: number;
  updateImplementation: string;
  beforeActiveStatus: any;
}

/**
 * @description - 获取游戏详情111
 */
export const queryGameInfoApi = (
  data: queryGameInfoOptions,
  options?: {
    headers?: object;
    meta?: AlovaMeta;
  }
) => {
  return withMeta(
    alovaInstance.Get<queryGameInfoRes, queryGameInfoOptions>(`/game/v1/info/detail`, {
      params: data,
      headers: {
        ...(options?.headers ?? {}),
        "Content-Type": "application/json"
      }
    }),
    options?.meta
  );
};
